import { createContext } from "react";

export const FormSectionContext = createContext<boolean>(false);
